import React from 'react'

const Footer = () => {
    return (
      <div className="footer" style={{left:'0px'}}>
        <h6 style={{ color: 'white !important' }}><b>Note:</b> For any queries and questions, Please contact to the given number - 8890010018</h6>
        Copyright © {process.env.REACT_APP_ORGANIZER_NAME}. All Rights Reserved.
      </div>
    );
}

export default Footer